/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowRampRight = createReactComponent("outline", "arrow-ramp-right", "IconArrowRampRight", [["path", { "d": "M7 3l0 8.707", "key": "svg-0" }], ["path", { "d": "M11 7l-4 -4l-4 4", "key": "svg-1" }], ["path", { "d": "M17 14l4 -4l-4 -4", "key": "svg-2" }], ["path", { "d": "M7 21a11 11 0 0 1 11 -11h3", "key": "svg-3" }]]);

export { IconArrowRampRight as default };
//# sourceMappingURL=IconArrowRampRight.mjs.map
